import React from 'react'

import { PoweroffOutlined } from '@ant-design/icons'
import { Row, Switch, Typography } from 'antd'
import { useFormikContext } from 'formik'

import { getMessage } from '../../../../../../util/IntlMessages'
import CustomInput from '../../../../../../components/CustomInput/customInput'
import { ActionPdfUpload } from '../ActionPdfUpload'
import { useActionType } from '../../hooks/useActionType'

import './styles.less'

export function ActionDetails() {
  const { values, setFieldValue, errors, handleBlur } = useFormikContext()

  const { isNewActionType } = useActionType()

  return (
    <>
      <Row className="actionTypeHeader">
        <Typography.Title level={3}>
          {isNewActionType ? getMessage('createActionTypes') : getMessage('updateActionTypes')}
        </Typography.Title>

        <div className="actionTypeHeader__activeWrapper">
          <PoweroffOutlined className="actionTypeHeader__activeIcon" />

          <div className="actionTypeHeader__activeSwitch">
            {getMessage('actionTypesActive')}

            <Switch
              onChange={(value) => setFieldValue('active', value)}
              checked={values?.active || false}
              unCheckedChildren={getMessage('label.inactive')}
              checkedChildren={getMessage('label.active')}
              defaultValue={true}
            />
          </div>
        </div>
      </Row>
      <Row type="flex" justify="start">
        <CustomInput
          field="name"
          errors={errors}
          setFieldValue={setFieldValue}
          rowSpan={12}
          value={values}
          handleBlur={handleBlur}
        />
        <ActionPdfUpload />
      </Row>
    </>
  )
}
